import React from 'react';
import PropTypes from 'prop-types';

const CustomMessage = ({cartMessage}) => {
  const {customMessage} = cartMessage;

  return <div className="cart__message" dangerouslySetInnerHTML={{__html: customMessage}} />;
};

CustomMessage.propTypes = {
  cartMessage: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
    customMessage: PropTypes.string.isRequired,
  }),
};

export default CustomMessage;
